import { useContext } from 'react';
import { ThemeContext } from '../../../context/ThemeContext';
// Enhanced theme utilities with proper dark mode support
export var useTheme = function () {
    var context = useContext(ThemeContext);
    if (!context) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
};
// Tab-specific color schemes that adapt to theme
export var getTabColorScheme = function (theme) { return ({
    overview: {
        gradient: theme === 'dark'
            ? 'from-blue-600 to-cyan-600'
            : 'from-blue-500 to-cyan-500',
        background: theme === 'dark'
            ? 'bg-blue-950/20 dark:bg-info-muted/30'
            : 'bg-info-muted',
        border: theme === 'dark'
            ? 'border-info'
            : 'border-info/20',
        text: theme === 'dark'
            ? 'text-info'
            : 'text-info'
    },
    chat: {
        gradient: theme === 'dark'
            ? 'from-purple-600 to-pink-600'
            : 'from-purple-500 to-pink-500',
        background: theme === 'dark'
            ? 'bg-purple-950/20 dark:bg-primary-muted/30'
            : 'bg-primary-muted',
        border: theme === 'dark'
            ? 'border-primary'
            : 'border-primary/20',
        text: theme === 'dark'
            ? 'text-primary'
            : 'text-primary'
    },
    flashcards: {
        gradient: theme === 'dark'
            ? 'from-green-600 to-emerald-600'
            : 'from-green-500 to-emerald-500',
        background: theme === 'dark'
            ? 'bg-green-950/20 dark:bg-success-muted/30'
            : 'bg-success-muted',
        border: theme === 'dark'
            ? 'border-success'
            : 'border-success/20',
        text: theme === 'dark'
            ? 'text-success'
            : 'text-success'
    },
    quiz: {
        gradient: theme === 'dark'
            ? 'from-orange-600 to-red-600'
            : 'from-orange-500 to-red-500',
        background: theme === 'dark'
            ? 'bg-orange-950/20 dark:bg-warning-muted/30'
            : 'bg-warning-muted',
        border: theme === 'dark'
            ? 'border-warning'
            : 'border-warning/20',
        text: theme === 'dark'
            ? 'text-warning'
            : 'text-warning'
    },
    podcast: {
        gradient: theme === 'dark'
            ? 'from-indigo-600 to-purple-600'
            : 'from-indigo-500 to-purple-500',
        background: theme === 'dark'
            ? 'bg-indigo-950/20 dark:bg-indigo-900/30'
            : 'bg-indigo-50',
        border: theme === 'dark'
            ? 'border-indigo-800'
            : 'border-indigo-200',
        text: theme === 'dark'
            ? 'text-indigo-300'
            : 'text-indigo-700'
    },
    mindmap: {
        gradient: theme === 'dark'
            ? 'from-teal-600 to-blue-600'
            : 'from-teal-500 to-blue-500',
        background: theme === 'dark'
            ? 'bg-teal-950/20 dark:bg-teal-900/30'
            : 'bg-teal-50',
        border: theme === 'dark'
            ? 'border-teal-800'
            : 'border-teal-200',
        text: theme === 'dark'
            ? 'text-teal-300'
            : 'text-teal-700'
    },
    definitions: {
        gradient: theme === 'dark'
            ? 'from-pink-600 to-rose-600'
            : 'from-pink-500 to-rose-500',
        background: theme === 'dark'
            ? 'bg-pink-950/20 dark:bg-pink-900/30'
            : 'bg-pink-50',
        border: theme === 'dark'
            ? 'border-pink-800'
            : 'border-pink-200',
        text: theme === 'dark'
            ? 'text-pink-300'
            : 'text-pink-700'
    },
    timeline: {
        gradient: theme === 'dark'
            ? 'from-yellow-600 to-orange-600'
            : 'from-yellow-500 to-orange-500',
        background: theme === 'dark'
            ? 'bg-yellow-950/20 dark:bg-warning-muted/30'
            : 'bg-warning-muted',
        border: theme === 'dark'
            ? 'border-warning'
            : 'border-warning/20',
        text: theme === 'dark'
            ? 'text-warning'
            : 'text-warning'
    }
}); };
// Enhanced animation classes that work in both themes
export var getAnimationClasses = function (theme) { return ({
    fadeIn: 'animate-in fade-in-0 duration-500',
    slideUp: 'animate-in slide-in-from-bottom-4 duration-300',
    scaleIn: 'animate-in zoom-in-95 duration-200',
    pulse: theme === 'dark'
        ? 'animate-pulse opacity-75'
        : 'animate-pulse opacity-60',
    glow: theme === 'dark'
        ? 'shadow-lg shadow-primary/25 dark:shadow-primary/10'
        : 'shadow-lg shadow-primary/10'
}); };
// Responsive breakpoint utilities
export var responsive = {
    mobile: 'sm:',
    tablet: 'md:',
    desktop: 'lg:',
    wide: 'xl:',
    ultrawide: '2xl:'
};
// Common spacing scale
export var spacing = {
    xs: 'space-y-2',
    sm: 'space-y-3',
    md: 'space-y-4',
    lg: 'space-y-6',
    xl: 'space-y-8'
};
